import { render } from "./about.vue?vue&type=template&id=4ec436d8"
const script = {}
script.render = render

export default script